import React, { useState, useEffect } from "react";
import { TbArrowUpDashed } from "react-icons/tb";

const SCROLL_THRESHOLD = 400;

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > SCROLL_THRESHOLD);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className="fixed bottom-[95px] right-[35px] sm:bottom-[120px] sm:right-[48px] z-50 w-[32px] h-[42px] flex items-center justify-center bg-white rounded-full hover:scale-110 transition-transform border-[3px] border-[#FE3D67]"
    >
      <TbArrowUpDashed className="text-[#FE3D67] text-[40px]" />
    </button>
  );
};

export default ScrollToTopButton;
